<template>
  <ml-table
          :loading="loading"
          :columns="columns"
          :dataSource="data"
          :rowSelection="rowSelection"
          size="small"
          rowKey="id"
          :pagination="false"
          bordered
          :selectRowKey="editdata && editdata.id"
          :scroll="{y: scrollY}"
          :canChangeColWidth="true"
  >
    <template slot="action" slot-scope="text, record">
      <a href="javascript:;" @click="handleEdit(record)">{{$t('edit')}}</a>
    </template>
    <template slot="icon" slot-scope="text">
      <a-icon :type="text" />
    </template>
    <template #kind="text">
      {{ menuKind[text] }}
    </template>
  </ml-table>
</template>

<script>

const columns = [
  {
    title: '菜单描述',
    dataIndex: 'name',
    key: 'name',
    width: 475,
    ellipsis: true
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    width: 60,
    scopedSlots: { customRender: 'action' },
  },
  {
    title: '菜单属性',
    dataIndex: 'kind',
    key: 'kind',
    ellipsis: true,
    width: 100,
    scopedSlots: { customRender: 'kind' },
  },
  {
    title: '菜单图标',
    dataIndex: 'source',
    key: 'source',
    scopedSlots: { customRender: 'icon' },
    ellipsis: true,
    width: 100,
    align:'center'
  },
  {
    title: '菜单排序',
    dataIndex: 'sort',
    key: 'sort',
    ellipsis: true,
    width: 100,
    align:'right'
  },
  {
    title: '菜单编号（多语言键）',
    dataIndex: 'code',
    key: 'code',
    ellipsis: true,
    width: 251
  },
  {
    title: '路由地址',
    dataIndex: 'path',
    key: 'path',
    ellipsis: true,
    width: 200
  },
  {
    title: '租户类型',
    dataIndex: 'audienceMsg',
    key: 'audienceMsg',
    ellipsis: true
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    ellipsis: true
  }
]
export default {
  name: 'MenuTable',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: ()=>([])
    },
    rowSelection: {
      type: Object
    },
    editdata: {
      type: Object
    },
    menuKind: {
      type: Object
    },
  },
  data () {
    return {
      columns,
      scrollY: window.document.body.clientHeight - 200
    }
  },
  methods: {
    handleEdit(r) {
      this.$emit('handleEdit', r)
    }
  }
}
</script>

<style scoped>

</style>
